module.exports = __webpack_public_path__ + "img/wxUrl-zs.9db194da.png";